import "../css/Login.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

const images = [
  // "/img/superadminbg1.png",
  "/img/superadminbg2.png",
  "/img/superadminbg5.png",
  "/img/superadminbg3.png",
  "/img/superadminbg4.png",
  "/img/superadminbg5.png",
];

const SuccessfulReset = () => {
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="login-container">
      <div className="login-left">
        {images.map((img, index) => (
          <div
            key={index}
            className={`bg-slide ${index === currentImage ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div>

      <div className="login-right d-flex flex-column justify-content-center align-items-start w-100">
        {/* Fixed Logo */}
        <div style={{ width: "100%", textAlign: "center" }}>
          <img
            className="zerobox-logo"
            src="/asset/Domatrix_Logo_White_crop.png"
            alt="Domatrix Logo"
          />
        </div>

        <div className="mx-auto text-center mt-4 p-4">
          {/* Success Icon */}
          <div className="mb-4">
            <img
              src="/asset/Successfully.png"
              alt="Success"
              style={{ height: "80px" }}
            />
          </div>

          {/* Message */}
          <h4 className="fw-bold">Successfully</h4>
          <p className="text-muted small">
            Your Password has been successfully Reset.
          </p>

          {/* Button */}
          <button
            className="btn custom-btn mt-3 w-100 fw-bold text-white p-2 "
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessfulReset;
